import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AvailableConfigurations } from '../../services/Ebootis.Queries/AvailableConfigurations';
import { Configuration } from '../../services/Ebootis.Queries/Configuration';
import { LobByOid } from '../../services/Ebootis.Queries/LobByOid';

@Injectable({
	providedIn: 'root',
})
export class StyleService implements OnDestroy {

	private readonly BRAND_LOGO_FALLBACK: string = './assets/logo.png';
	private appLogoSrcBehaviorSubject: BehaviorSubject<string> = new BehaviorSubject(this.BRAND_LOGO_FALLBACK);
	public appLogoSrc: Observable<string> = this.appLogoSrcBehaviorSubject.asObservable();
	public readonly CUSTOM_STYLESHEET_ID: string = 'customStyle';
	private readonly STYLESHEET_URL: string = 'assets/style.css';
	private readonly STYLESHEET: string = 'stylesheet';
	constructor(
		private m_configurations: AvailableConfigurations,
		private m_currentConfiguration: Configuration,
		private m_lobByOid: LobByOid,
	) {
		this.createCustomStyleSheetElement(this.STYLESHEET_URL, this.STYLESHEET);
	}

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
	}

	setAppLogoSrc(p_src: string) {
		this.appLogoSrcBehaviorSubject.next(p_src);
	}


	/**
	 * Das geladene Benutzerdefinierte Logo wird entfernt.
	 */
	public removeCustomStyleSheet(p_id: string): void {
		this.appLogoSrcBehaviorSubject.next(this.BRAND_LOGO_FALLBACK);
		const element: HTMLElement = document.getElementById(p_id);
		if (element) {
			element.remove();
		}
	}

	/**
	 * Es wird eine Benutzerdefinierte CSS Datei geladen. Dabei wird entweder ein neuer Stylesheet Eintrag erstellt oder ein vorhandener überschrieben.
	 * @param p_configObjectOid OID des Objektes aus der Konfiguration
	 */
	public createCustomStyleSheetElement(p_cssFile: string, p_id: string): void {
		let element: HTMLElement = document.getElementById(p_id);
		if (!element) {
			element = document.createElement('link');
			element.setAttribute('rel', 'stylesheet');
			element.id = p_id;
			element.setAttribute('href', p_cssFile);
			document.querySelector('head').appendChild(element);
		} else {
			element.setAttribute('href', p_cssFile);
		}
	}
}

